import React, { useCallback, useEffect, useRef, useState } from "react";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import { useDispatch } from "react-redux";
import { showAlert } from "../../reducers/alertSlice";
import { httpRequest, onRequestError, printLog } from "../../helper/global";
import { useNavigate } from "react-router-dom";

import { Box } from "@mui/material";
import TinyMCE from "../TinyMCE/TinyMCE";

export default function EmailTemplate({
    theme,
    user,
    permissionConfig,
    isOpen = false,
    onClose = null,
    initialTemplateId = null,
    initialTitle = "",
    initialContent = "",
    updateTempleteResults = null,
}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [title, setTitle] = useState(initialTitle);
    const [content, setContent] = useState(initialContent);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };
    const handleSave = useCallback(async () => {
        // handle save logic here

        if (!title.trim()) {
            dispatch(
                showAlert({
                    title: "",
                    message: `Please provide a template title.`,
                })
            );

            return;
        }

        const postData = {};
        postData.title = title.trim();
        // Get content from TinyMCE via state

        // Replace all occurrences of style= with $style= in content
        const processedContent = content.replace(/style=/gi, "$style=");

        postData.content = processedContent;

        if (initialTemplateId) {
            postData.templateId = initialTemplateId;
        }

        try {
            const result = await httpRequest(
                `email/update`,
                postData,
                "POST",
                (error) => {
                    onRequestError(dispatch, navigate, {
                        title: error.title,
                        message: error.message,
                    });

                    handleClose();
                }
            );

            if (result === false) {
                return;
            }

            if (updateTempleteResults) {
                updateTempleteResults(result.payload);
            }

            handleClose();
            // printLog(result, true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }, [initialTemplateId, title, content, dispatch]);

    useEffect(() => {
        setTitle(initialTitle);

        setContent(initialContent);
    }, [isOpen, initialTitle, initialContent]);

    // No manual cleanup needed for TinyMCE Editor; let the component handle its own lifecycle

    return (
        <>
            <Box>
                <Box display={"flex"} justifyContent="flex-end" mb={1} gap={1}>
                    <Button
                        size="small"
                        onClick={handleClose}
                        variant="contained"
                        color="primary"
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        onClick={handleSave}
                        color="primary"
                        variant="contained"
                    >
                        Save
                    </Button>
                </Box>
                <TextField
                    size="small"
                    label="Template Title"
                    fullWidth
                    margin="normal"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <Box
                    sx={{
                        height: { xs: "375px", lg: "480px", xl: "480px" },
                    }}
                >
                    <TinyMCE
                        theme={theme}
                        initialContent={initialContent}
                        onContentChange={setContent}
                    />
                </Box>
            </Box>
        </>
    );
}
